import React from 'react';

import classes from './HostInfo.module.scss';
import { AvatarIcon } from '../../../../../shared/components/ui-components';

type HostInfoProps = {
  hostName: string;
  avatarUrl?: string;
};

const HostInfo = ({ hostName, avatarUrl }: HostInfoProps) => {
  return (
    <div className={classes.container}>
      <AvatarIcon userName={hostName} avatarImgLink={avatarUrl} size="small" />
      <div className={classes.titleBlock}>
        <p className={classes.title}>Host</p>
        <p className={classes.description}>{hostName}</p>
      </div>
    </div>
  );
};

export { HostInfo };
